/**
 * <announcement-bar>
 * ---------------------------------------------------------------------------
 * Rota los mensajes de la barra superior.
 *
 * Decisiones:
 *   - Con un solo mensaje no arranca ningún temporizador.
 *   - Se detiene cuando la pestaña no está visible: nada de animar en segundo plano.
 *   - Respeta `prefers-reduced-motion`: quien lo tenga activado ve el primer
 *     mensaje fijo, sin rotación.
 */

class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-announcement-item]'));
    if (this.items.length < 2) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.index = 0;
    this.interval = Number(this.dataset.rotateEvery) || 5000;

    this.start();
    document.addEventListener('visibilitychange', this.#onVisibilityChange);
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.#onVisibilityChange);
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    this.items[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.items.length;
    this.items[this.index].classList.add('is-active');
  }

  #onVisibilityChange = () => {
    if (document.hidden) {
      this.stop();
    } else {
      this.start();
    }
  };
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
